document.addEventListener('DOMContentLoaded', () => {
  globalInitAddToCart();
  globalInitOpenCartFromUrl();
  globalInitHeaderScroll();
  globalInitSearchDrawer();
  globalInitSideMenu();
});

function globalInitAddToCart() {
  const addToCartForms = document.querySelectorAll('form[action$="/cart/add"]');

  addToCartForms.forEach((form) => {
    if (form.dataset.cartBound === 'true') return;
    form.dataset.cartBound = 'true';
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      if (form.dataset.submitting === 'true') return;

      const submitButton = form.querySelector('[data-product-add-to-cart]');
      const variantIdInput = form.querySelector('[data-product-variant-id]');
      if (
        submitButton?.disabled ||
        (variantIdInput && !variantIdInput.value.trim())
      ) {
        return;
      }
      
      form.dataset.submitting = 'true';
      clearCartError();

      const loader = form.querySelector('.js-loader');
      const formData = new FormData(form);

      if (loader) loader.classList.remove('hidden');
      submitButton?.classList.add('opacity-70', 'pointer-events-none');

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          body: formData,
        });

        if (!response.ok) {
          const message = await getCartErrorMessage(
            response,
            "Impossible d’ajouter cet article au panier."
          );
        
          showCartError(message);
          return;
        }
        
        const cartData = await response.json();
        
        document.dispatchEvent(
          new CustomEvent('cart:updated', {
            bubbles: true,
            detail: {
              product: cartData,
              form,
            },
          })
        );
        
      } catch (error) {
        console.error("Erreur lors de l'ajout :", error);
      
        showCartError(
          "La confirmation de l’ajout n’a pas pu être reçue. " +
          "Actualisez la page et vérifiez votre panier avant de réessayer."
        );
      } finally {
        if (loader) loader.classList.add('hidden');
        delete form.dataset.submitting;
        submitButton?.classList.remove('opacity-70', 'pointer-events-none');
      }
    });
  });
}

function globalInitOpenCartFromUrl() {
  if (sessionStorage.getItem('open_cart_drawer') === 'true') {
    sessionStorage.removeItem('open_cart_drawer');
    window.CartDrawer.open();
  }
}

function globalInitHeaderScroll() {
  const header = document.getElementById('main-header');
  const stickyNavs = document.querySelectorAll('.sticky-nav');

  if (!header) return;

  let lastScrollTop = 0;
  const scrollThreshold = 50;

  const getHeaderHeight = () => header.offsetHeight;

  // Initial state
  stickyNavs.forEach((nav) => {
    nav.style.top = `${getHeaderHeight()}px`;
  });

  window.addEventListener('scroll', () => {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if (scrollTop < 0) return;

    if (scrollTop > lastScrollTop && scrollTop > scrollThreshold) {
      header.classList.add('-translate-y-full');
      stickyNavs.forEach((nav) => {
        nav.style.top = '0px';
      });
    } else {
      header.classList.remove('-translate-y-full');
      const headerHeight = getHeaderHeight();
      stickyNavs.forEach((nav) => {
        nav.style.top = `${headerHeight}px`;
      });
    }

    lastScrollTop = scrollTop;
  });
}

function globalInitSearchDrawer() {
  const openBtn = document.querySelector('.open-search');
  const overlay = document.getElementById('search-overlay');
  const drawer = document.querySelector('.search-drawer');
  const input = drawer?.querySelector('input[type="search"]');

  if (!openBtn || !overlay || !drawer) return;

  const openSearch = () => {
    drawer.classList.replace('-translate-y-full', 'translate-y-0');
    overlay.classList.remove('hidden');
    setTimeout(() => input?.focus(), 300);
  };

  const closeSearch = () => {
    drawer.classList.replace('translate-y-0', '-translate-y-full');
    overlay.classList.add('hidden');
  };

  openBtn.addEventListener('click', openSearch);

  document.addEventListener('click', (e) => {
    if (!drawer.contains(e.target) && !openBtn.contains(e.target) && drawer.classList.contains('translate-y-0')) {
      closeSearch();
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeSearch();
  });
}

function globalInitSideMenu() {
  const sideMenu = document.getElementById('side-menu');
  const overlay = document.getElementById('menu-overlay');
  const openBtn = document.getElementById('hamburger-btn');
  const closeBtn = document.getElementById('close-menu');

  if (!sideMenu || !overlay || !openBtn) return;

  const open = () => {
    sideMenu.classList.remove('-translate-x-full');
    overlay.classList.remove('hidden');
    document.body.style.overflow = 'hidden';
  };

  const close = () => {
    sideMenu.classList.add('-translate-x-full');
    overlay.classList.add('hidden');
    document.body.style.overflow = '';
  };

  openBtn.addEventListener('click', open);
  closeBtn?.addEventListener('click', close);
  overlay.addEventListener('click', close);
}

function clearCartError() {
  const notice = document.getElementById('cart-error-notice');
  const message = document.getElementById('cart-error-message');

  if (message) message.textContent = '';
  notice?.classList.add('hidden');
}

function showCartError(text) {
  const notice = document.getElementById('cart-error-notice');
  const message = document.getElementById('cart-error-message');

  if (!notice || !message) return;

  notice.classList.remove('hidden');
  message.textContent = text;
}

async function getCartErrorMessage(response, fallback) {
  const data = await response.json().catch(() => null);

  if (typeof data?.description === 'string') {
    return data.description;
  }

  if (typeof data?.message === 'string') {
    return data.message;
  }

  return fallback;
}